import * as ROUTES from 'Routes'
import { ROOT_URL } from 'gatsby-env-variables'
import analytics from '@mobi/libraries/analytics'
import { navigate } from 'gatsby'
import classNames from 'classnames'
import Text from 'components/Text'
import Button from 'components/Button'
import router from 'utils/router'
import { ThemeContext } from 'modules/Theme'
import './LandingFooter.scss'
import { useContext } from 'react'
import { handlePerformanceMark } from 'utils/trackings/newRelicEvents'
import { socialMediaIcons } from './constants'

const LandingFooter = () => {
  const { theme } = useContext(ThemeContext)

  const isRecoveryOrigin = theme === 'recovery'

  const handleGetYear = new Date().getFullYear()

  const handleTracking = (ev) => {
    const elementClickedPayload = {
      location: ev.currentTarget.dataset.trackingLocation,
      position: ev.currentTarget.dataset.trackingPosition,
      elementType: ev.currentTarget.dataset.trackingElement,
      text: ev.currentTarget.textContent || ev.currentTarget.ariaLabel,
      htmlId: ev.currentTarget.dataset.unique,
      actionOutcome: ev.currentTarget.dataset.trackingActionoutcome,
      outboundUrl: ev.currentTarget.dataset.trackingOutboundurl,
    }

    analytics.track('elementClicked', elementClickedPayload)
    analytics.track('segmentButtonClick', {
      name: `${elementClickedPayload.text}:Footer`,
      id: elementClickedPayload.htmlId,
    })
  }
  const renderItauContainer = () => {
    return (
      <div className="container-itau">
        <Text
          p
          size={1}
          className="label-text label-text__white itau-company"
          aria-label={`Recovery é uma empresa Itaú`}
          role="complementary"
        >
          <span aria-hidden="true">
            <b>Recovery</b> é uma empresa
          </span>

          <img
            alt="Logo Itaú"
            loading="lazy"
            className="itau-company__img"
            aria-hidden="true"
            src="/icons/logo-itau.svg"
          />
        </Text>
        <Text p size={1} className="label-text label-text__white itau-text">
          © {handleGetYear} Itaú Unibanco Holding S.A.
        </Text>
        <Text p size={1} className="label-text label-text__white itau-text">
          CNPJ: 05.032.035/0001-26
        </Text>
        <Text p size={1} className="label-text label-text__white">
          Praça Alfredo Egydio de Souza Aranha, 100, Torre Olavo Setubal, Parque
          Jabaquara - CEP 04344-902 - São Paulo - Brasil
        </Text>
      </div>
    )
  }

  const footerClassnames = classNames('landing-footer-container', {
    'landing-footer-container__generalTheme': !isRecoveryOrigin,
  })

  return (
    <div className={footerClassnames}>
      <div className="landing-footer-content">
        <div className="footer-left-part">
          <div className="logo">
            <img
              src="/images/logo_recovery.svg"
              alt="Logo Recovery"
              loading="lazy"
            />
          </div>
          <Text h2 size={3} className="footer-main-text">
            Transformando dívidas em recomeços
          </Text>
          <Button
            className="left-part-button"
            onClick={() => {
              analytics.track('segmentButtonClick', {
                name: 'ConsultarCpf:Footer',
                id: '33e4d860-1f1b-47b8-a65e-d30f08c67647',
              })
              handlePerformanceMark(ROUTES.register.pageName)
              navigate(ROUTES.register.path, {
                state: {
                  source_url: location.href,
                  mp_uuid: router.getQueryString('mp_uuid'),
                },
              })
            }}
            data-unique="33e4d860-1f1b-47b8-a65e-d30f08c67647"
            data-test="footer-consult-debt-button"
            data-tracking-location="footer"
            data-tracking-position="footer-cta"
            data-tracking-actionoutcome="check_cpf"
            data-tracking-element="button"
            data-tracking-outboundurl={`${ROOT_URL}${ROUTES.register.path}`}
          >
            Consultar dívidas
          </Button>
        </div>

        <div className="footer-right-part">
          <a
            className="label-text label-text__bold label-text__bold-first"
            href="https://www.gruporecovery.com/"
            target="_blank"
            rel="noreferrer"
            data-tracking-location="footer"
            data-tracking-position="footer-link"
            data-tracking-actionoutcome="redirect"
            data-tracking-element="link"
            data-tracking-outboundurl="https://www.gruporecovery.com/"
            onClick={handleTracking}
          >
            Grupo Recovery
          </a>

          <a
            className="label-text label-text__bold"
            href="https://www.gruporecovery.com/termos-de-utilizacao/"
            target="_blank"
            rel="noreferrer"
            data-tracking-location="footer"
            data-tracking-position="footer-link"
            data-tracking-actionoutcome="redirect"
            data-tracking-element="link"
            data-tracking-outboundurl="https://www.gruporecovery.com/termos-de-utilizacao/"
            onClick={handleTracking}
          >
            Política de privacidade
          </a>

          <Text
            p
            size={9}
            className="label-text margin-links label-text__white"
          >
            CNPJ: 05.032.035/0001-26
          </Text>

          <Text
            p
            size={9}
            className="label-text margin-icons label-text__white"
          >
            Avenida Paulista, 1294, 18º andar Bela Vista, São Paulo/SP
          </Text>

          <div className="icon-container" data-test="footer-icon-container">
            {socialMediaIcons.map((item) => (
              <a
                href={item.url}
                aria-label={item.name}
                key={item.id}
                target="_blank"
                rel="noreferrer"
                data-tracking-location="footer"
                data-tracking-position="footer-social-media"
                data-tracking-actionoutcome="redirect"
                data-tracking-element="link"
                data-tracking-outboundurl={item.url}
                onClick={handleTracking}
              >
                <div className="item-icon">{item.icon}</div>
              </a>
            ))}
          </div>

          <Text p size={1} className="label-text label-text__white">
            © Copyright {handleGetYear} Grupo Recovery, Todos os direitos
            reservados
          </Text>
          {renderItauContainer()}
        </div>
      </div>
    </div>
  )
}

export default LandingFooter
